import { render, staticRenderFns } from "./foodPolicy.vue?vue&type=template&id=47c72da8&scoped=true&"
import script from "./foodPolicy.vue?vue&type=script&lang=js&"
export * from "./foodPolicy.vue?vue&type=script&lang=js&"
import style0 from "./foodPolicy.vue?vue&type=style&index=0&id=47c72da8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c72da8",
  null
  
)

export default component.exports